import $ from 'jquery'
import { setSameHeight, generateProductHTML } from '../abstracts/utils'
/* eslint-disable */
export default function() {
  $(function() {
    if (!$('body').hasClass('search') || !$('body').hasClass('search-results')) return

    let $sectionProducts = $('.section-products')
    setSameHeight($sectionProducts.find('.products .product .product__content'))

    // load more
    $('.load-more-cta a').on('click', function(e) {
      let btn = $(e.target)
      let currentPage = parseInt(btn.attr('current-page'))
      let nextPage = currentPage + 1

      $.get(window.endpoint + '/get-products-by-keywords', {
        /* eslint-disable */
        'posts_per_page': localVar['posts_per_page'],
        'page': nextPage,
        'keywords': localVar['keywords']
      })
        .done(res => {
          if (res.products && res.products.length) {
            for (let i = 0; i < res.products.length; i++)
              $sectionProducts.find('.products').append(generateProductHTML(res.products[i]))
          }

          if (nextPage < res.max_num_pages) {
            btn.attr('current-page', nextPage)
          } else {
            btn.hide()
          }
          setSameHeight($sectionProducts.find('.products .product .product__content'))
        })
        .fail(err => {
          console.log(err)
        })
    })
  })
}
